import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import {
    ILoyaltyBonusType,
    ILoyaltyBonusTypeListItem,
    LoyaltyBonusTypeResponseType
} from '@/entity/loyalty/loyaltyBonus/loyaltyBonusType/LoyaltyBonusType.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { LoyaltyBonusTypeGeneralRequestType } from '@/form/loyalty/loyaltyBonusType/LoyaltyBonusTypeGeneral.types';
import { ResponseDataType } from '@/form/form.types';
import { createLogger } from 'vuex';
import { prepareFormData } from '@/store/utils/formDataHelper';
@Module({
    namespaced: true,
    name: 'loyaltyBonusType',
    store,
    dynamic: true
})
class LoyaltyBonusTypeModule extends VuexModule {
    loyaltyBonusTypes: ILoyaltyBonusType | null = null;
    loyaltyBonusType: ILoyaltyBonusTypeListItem | null = null;
    loyaltyBonusTypeLoaded = false;
    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ loyaltyBonusTypes: ILoyaltyBonusType; loyaltyBonusTypeLoaded: boolean }> {

        let loyaltyBonusTypeLoaded = false;
        const loyaltyBonusTypes = await store.$repository.loyaltyBonusType.fetchAll(prepareFormData(data));
        if (loyaltyBonusTypes) {
            loyaltyBonusTypeLoaded = true;
        }
        return { loyaltyBonusTypes, loyaltyBonusTypeLoaded };
    }
    @Action({ rawError: true })
    async create(data: LoyaltyBonusTypeGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltyBonusType.create(data);
    }
    @Action({ rawError: true })
    async update(data: LoyaltyBonusTypeGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.loyaltyBonusType.update(data);

    }
    /*@MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: ILoyaltyBonusTypeListItem  ; counterpartiesLoaded: boolean }> {
        let counterpartiesLoaded = false;
        const salon = await store.$repository.counterparties.fetchData(data);
        if (salon) {
            counterpartiesLoaded = true;
        }
        return { salon, counterpartiesLoaded};
    }
    @Action({rawError: true})
    async create(data: LoyaltyBonusTypeGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: LoyaltyBonusTypeGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.counterparties.delete(data);
        return resp;
    }*/
}

export const LoyaltyBonusTypeStore = getModule(LoyaltyBonusTypeModule);
